export function CurrentAcademicYear() {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const nextYear = currentYear + 1;
      
    const currentAcademicYear = `${currentYear}-${nextYear}`;
    const nextAcademicYear = `${nextYear}-${nextYear + 1}`;
      
    return [currentAcademicYear, nextAcademicYear];
}

export function generateFinancialYears() {
    const currentYear = new Date().getFullYear();
    const financialYears = [];
  
    for (let i = 0; i < 6; i++) {
        const startYear = currentYear - i;
        const endYear = startYear + 1;
        const financialYear = `FY ${startYear}-${endYear.toString().substring(2)}`;
        financialYears.push(financialYear);
    }
  
    return financialYears;
}